"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var NoOp = function NoOp() {
  return undefined;
};
var useTableFunctions = function useTableFunctions() {
  var ref = (0, _react.useRef)({
    clearSelections: NoOp,
    exportData: NoOp,
    setSelections: NoOp,
    scrollToId: NoOp,
    deleteRow: NoOp,
    addRow: NoOp,
    updateRow: NoOp,
    updateData: NoOp,
    getRows: function getRows() {
      return [];
    }
  });
  var table = {
    clearSelections: function clearSelections() {
      return ref.current.clearSelections();
    },
    exportData: function exportData() {
      var _ref$current;
      return (_ref$current = ref.current).exportData.apply(_ref$current, arguments);
    },
    setSelections: function setSelections(ids) {
      return ref.current.setSelections(ids);
    },
    scrollToId: function scrollToId(id) {
      return ref.current.scrollToId(id);
    },
    deleteRow: function deleteRow(index) {
      return ref.current.deleteRow(index);
    },
    addRow: function addRow(row) {
      return ref.current.addRow(row);
    },
    updateRow: function updateRow(row, index) {
      return ref.current.updateRow(row, index);
    },
    updateData: function updateData(rowIndex, columnId, value) {
      return ref.current.updateData(rowIndex, columnId, value);
    },
    getRows: function getRows() {
      return ref.current.getRows();
    }
  };
  return [ref, table];
};
var _default = exports.default = useTableFunctions;